import { useSessionStorageState } from 'ahooks'
import { useEffect, useState } from 'react'
import { FLOW_ERROR_LOG } from '@/features/logger/constants'

export function useFlowRunArgs() {
  const [runArgs, setRunArgs] = useState<Record<string, any>>({})
  // 标记尝试错误重试的输入参数
  const [flowErrorLog] = useSessionStorageState<any>(FLOW_ERROR_LOG)

  useEffect(() => {
    if (flowErrorLog) {
      setRunArgs(flowErrorLog?.initialInputFormData || {})
    }
  }, [flowErrorLog])

  return {
    runArgs,
    setRunArgs,
  }
}
